import { PathsE, LayoutsE } from "shared/routes";

export default function useGenerateUrl<
  PathParams extends Record<string, string> = undefined,
  SearchParams extends Record<string, string> = undefined,
>(
  path: PathsE,
  layout: LayoutsE = LayoutsE.DASHBOARD,
  pathsParams?: PathParams,
  searchParams?: SearchParams,
) {
  const pathname = `/${layout}/${path}`.replace(/:\w+/g, (match) => {
    const key = match.slice(1);
    return pathsParams && pathsParams[key] !== undefined
      ? pathsParams[key]
      : match;
  });

  const search = searchParams
    ? `?${Object.entries(searchParams)
        .flatMap(([key, value]) => {
          return value == null ? [] : `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
        })
        .join("&")}`
    : "";

  return `${pathname}${search}`;
}
